module.exports = __webpack_public_path__ + "static/media/IconMenuC.3582c47b.svg";